import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import FellowsPage from './pages/FellowsPage';
import FellowProfilePage from './pages/FellowProfilePage';
import PresentationsPage from './pages/PresentationsPage';
import MeetingsPage from './pages/MeetingsPage';
import AnnouncementsPage from './pages/AnnouncementsPage';
import ResourcesPage from './pages/ResourcesPage';
import TasksPage from './pages/TasksPage';
import CalendarPage from './pages/CalendarPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AdminPage from './pages/AdminPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ProfileSettingsPage from './pages/ProfileSettingsPage';
import PollsPage from './pages/PollsPage';
import SupervisorPage from './pages/SupervisorPage';
import NotFoundPage from './pages/NotFoundPage';

function ProtectedRoute({ children, adminOnly = false, supervisorAllowed = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-gray-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-gray-400">Loading...</div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'admin' ? '/admin-home' : user.role === 'supervisor' ? '/supervisor' : '/dashboard'} /> : <LoginPage />} />
      <Route path="/" element={<Navigate to={user?.role === 'admin' ? '/admin-home' : user?.role === 'supervisor' ? '/supervisor' : '/dashboard'} />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/admin-home" element={<ProtectedRoute adminOnly><AdminDashboardPage /></ProtectedRoute>} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/fellows" element={<FellowsPage />} />
        <Route path="/fellows/:id" element={<FellowProfilePage />} />
        <Route path="/presentations" element={<PresentationsPage />} />
        <Route path="/meetings" element={<MeetingsPage />} />
        <Route path="/announcements" element={<AnnouncementsPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/polls" element={<PollsPage />} />
        <Route path="/supervisor" element={<SupervisorPage />} />
        <Route path="/profile" element={<ProfileSettingsPage />} />
        <Route path="/analytics" element={<ProtectedRoute adminOnly><AnalyticsPage /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
